import { QUERY_KEYS } from '@24i/nxg-sdk-photon';
import { PersistedClient } from 'react-query/persistQueryClient-experimental';

export const handlePersistStorage = (
    client: PersistedClient,
    persistorKeys: (QUERY_KEYS | string | string[])[] = []
) => {
    const filteredQueries = client.clientState.queries.filter((query) => {
        const queryKeyStr = Array.isArray(query.queryKey)
            ? query.queryKey.join('/')
            : String(query.queryKey);

        return persistorKeys.some((pk) => {
            const pkStr = Array.isArray(pk) ? pk.join('/') : String(pk);
            // Match exact key or prefix
            return queryKeyStr === pkStr || queryKeyStr.startsWith(`${pkStr}/`);
        });
    });

    return JSON.stringify({
        ...client,
        clientState: {
            ...client.clientState,
            queries: filteredQueries,
        },
    });
};
